import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './modules/shared/services/error-service';
import { ToastService } from './modules/shared/services/toast.service';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private injector: Injector, private router: Router) {}

    handleError(error: Error | HttpErrorResponse) {
        const errorService = this.injector.get(ErrorService);
        const toast = this.injector.get(ToastService);

        let message;
        let errorPlusStackTrace;

        let infoMessage =
            'An error has occured. The team is being notified and will work to resolve this in a future release.';

        if (error instanceof HttpErrorResponse) {
            // Server Error
            message = errorService.getServerMessage(error);
            if (!environment.production) {
                toast.warningAlert(message, { timeout: 0 });
            } else {
                toast.warningAlert(infoMessage, { timeout: 10000 });
            }

            console.error('An unexpected server error occurred.');
        } else {
            // Client Error
            errorPlusStackTrace = errorService.getClientStack(error);

            if (!environment.production) {
                toast.warningAlert(errorPlusStackTrace, { timeout: 0 });
            }

            console.error(error);
        }
        throw error;
    }
}
